module.exports = __webpack_public_path__ + "front/img/18.64ccd5ec.jpg";